import {customSize} from '../design/configurator/room/custom-layout';

// Keep fit guidance in sync with the actual Design Studio configuration.
const size=customSize('rosemary',0);
export const ERNST_SPAN = size.width;
export const ERNST_DEPTH = size.depth;
export type PreviewLayout = 'ernst' | 'basic' | 'castle';
export function ernstSpanStatus(value: string | number | undefined) {
 const inches=Number(value);
 if(!Number.isFinite(inches)||inches<=0)return 'unknown';
 return inches<ERNST_SPAN?'too-small':'eligible';
}
